import { Box, Button, CloseButton, Flex, Text, VStack } from '@chakra-ui/react'
import { PlayIcon } from '@components/icons'
import JoinWaitlistButton from '@handlers/sessions/components/join-waitlist'
import React from 'react'

interface EhrWaitlistBannerProps {
  onClose: () => void
  onPlayVideo: () => void
}

const Image =
  'https://res.cloudinary.com/hellojoy/image/upload/v1746748024/76835dc451aacd40efdfac738dd16631f0067cfb_vlfjkt.png'

export const EhrWaitlistBanner = ({
  onClose,
  onPlayVideo
}: EhrWaitlistBannerProps) => {
  return (
    <Flex
      direction={{ base: 'column', md: 'row' }}
      bg="#F6F7FE"
      borderRadius="12px"
    >
      <CloseButton
        position="absolute"
        top="10px"
        right="10px"
        onClick={onClose}
        bg="white"
        color="primary"
        zIndex="1"
        _hover={{ bg: '#F9F9F9' }}
        _active={{ bg: '#F9F9F9' }}
        data-click-text="Close EHR Waitlist Banner"
      />

      <Box flex="4" py={{ base: 6, md: 8 }} px={{ base: 6, md: 10 }}>
        <VStack align="start" spacing={4}>
          <Text fontSize="lg" color="#2D54E8">
            A new era of AI-assisted EHR is coming
          </Text>
          <Text color="gray.700" fontSize="md">
            Therapists. Deserve. Better. That's why Blueprint is introducing a
            brand new type of EHR — one that fades into the background and lets
            you <strong>focus on what you do best — helping people.</strong>
          </Text>
          <Flex gap={4} flexWrap="wrap" alignItems="center">
            <JoinWaitlistButton
              feature="ehr"
              buttonText="Join the waitlist"
              width="180px"
              height="32px"
              fontSize="14px"
              data-click-text="Join EHR Waitlist"
            />
            <Button
              ml="0px"
              w="180px"
              variant="outline"
              onClick={onPlayVideo}
              leftIcon={<PlayIcon width="16px" height="16px" color="black" />}
              _hover={{
                bg: 'rgba(45, 84, 232, 0.04) '
              }}
              _focus={{
                outline: 'none'
              }}
              fontSize="14px"
              h="32px"
              data-click-text="Learn how EHR works"
            >
              Learn how it works
            </Button>
          </Flex>
        </VStack>
      </Box>
      <Box
        position="relative"
        flex="3"
        cursor="pointer"
        onClick={onPlayVideo}
        bgImage={`url(${Image})`}
        bgSize="cover"
        bgPosition="center"
        bgRepeat="no-repeat"
        pb={{ base: '240px', sm: '0' }}
        borderBottomRightRadius="8px"
        borderBottomLeftRadius={{ base: '8px', sm: '0' }}
        borderTopRightRadius={{ base: '0', sm: '8px' }}
      >
        <Box
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          bg="white"
          borderRadius="50%"
          h="48px"
          w="48px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          _hover={{
            bg: '#F9F9F9'
          }}
        >
          <PlayIcon color="black" height="30px" width="30px" />
        </Box>
      </Box>
    </Flex>
  )
}
